import React from "react";
import { ReactComponent as ResetIcon } from "../../../img/reset-icon.svg";
import { resetReceiver } from "../../../utils/swapAndSendUtils";
import { GlobalStore } from "../../../store/global/GlobalStore";

interface ClearReceiverProps {
  visible: boolean;
}

export const ClearReceiver: React.FC<ClearReceiverProps> = ({ visible }) => {
  const theme = GlobalStore.useState(s => s.theme);

  if (!visible) {
    return null;
  }

  return (
    <ResetIcon
      type="button"
      data-testid="clear-receiver"
      onClick={() => {
        resetReceiver();
      }}
      fill={theme.button.secondary.surface.default}
      stroke={theme.button.secondary.surface.default}
    />
  );
};
